import React from "react";
import PropTypes from "prop-types";
import {AButton} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";

const GraphToolbarItem = ({
  title,
  icon,
  onClick,
  disabled,
  className,
  ...otherProps
}) => (
  <AButton
    title={title}
    medium
    icon
    secondary
    onClick={onClick}
    disabled={disabled}
    className={classNames("mr-1", className)}
    {...otherProps}>
    {icon}
  </AButton>
);

GraphToolbarItem.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  classNames: PropTypes.string
};

export default GraphToolbarItem;
